import { store } from "../state/StateStore";
import { StorageService } from "../services/StorageService";

export class RetrySystem {
  /** Reset game state for retry */
  retry(): void {
    // Save high score before reset
    const state = store.get();
    if (state.score > state.highScore) {
      StorageService.saveHighScore(state.score);
    }
    store.reset();
    // Reload high score
    store.set({ highScore: StorageService.loadHighScore() });
  }

  /** Trigger game over */
  gameOver(): void {
    const state = store.get();
    const highScore = Math.max(state.score, state.highScore);
    StorageService.saveHighScore(highScore);
    store.set({
      isGameOver: true,
      highScore,
    });
  }
}
